import React from "react";

import StatusBadge from "../../../../components/status-badge/StatusBadge";
import ToolTip from "../../../../components/tooltip/ToolTip";
import { ShotCommentHover } from "../../../../components/markdown/ShotCommentHoverCard";
import { useGetShotCommentsQuery } from "../../../../app/services/shotComments";

interface CheckbackBadgeProps {
  /** チェックバック（プロデューサー待ち）状態のショット ID */
  shotId: string;
}

/**
 * チェックバック中ショットと同名のタスク行タイトル横に差し込む「CB」タグ。
 * ホバーで最新のクライアントチェックバックコメント（最新の未解決コメント。
 * Home のやることカードと同じ API）をホバーカード（本文＋ピン先メディアの
 * プレビュー）で表示する。未解決コメントが無い場合はテキストツールチップ。
 * ショットのステータス変化で自動的に消えるレンダー時判定のため、
 * タスク側への永続化は行わない。
 */
const CheckbackBadge: React.FC<CheckbackBadgeProps> = ({ shotId }) => {
  const { data } = useGetShotCommentsQuery(
    { shot_id: shotId, filter: "latest_unresolved", limit: 1 },
    { skip: !shotId },
  );

  const latest = data?.data?.comments?.[0];

  // Tippy がホバー対象として受け取れるよう inline-flex でラップする
  const badge = (
    <span style={{ display: "inline-flex", flexShrink: 0 }}>
      <StatusBadge variant="chip" color="blue" size="small" label="CB" />
    </span>
  );

  if (latest) {
    return (
      <ShotCommentHover shotId={shotId} commentId={latest.id}>
        {badge}
      </ShotCommentHover>
    );
  }
  return (
    <ToolTip description="チェックバック対応待ち（未解決コメントはありません）">
      {badge}
    </ToolTip>
  );
};

export default CheckbackBadge;
